import { render, staticRenderFns } from "./MemberSubmenuTabMember.vue?vue&type=template&id=2d6c0810&"
import script from "./MemberSubmenuTabMember.vue?vue&type=script&lang=js&"
export * from "./MemberSubmenuTabMember.vue?vue&type=script&lang=js&"
import style0 from "./MemberSubmenuTabMember.vue?vue&type=style&index=0&id=2d6c0810&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports